import {APIService} from "../../common/APIService";
import {Contact, ContactSex, ContactType} from "../../dto/Contact";

export class ContactService extends APIService {
  public async browse() {
    const json = await this.getJson<{data: object[]}>(`contacts`)
    return json.data.map(item => Contact.fromJson(item))
  }

  public async add(firstName: string, middleName: string, lastName: string, type: ContactType, phone: string, email: string, sex: ContactSex|null, relationId: string): Promise<Contact> {
    const json = await this.postJson<{ data: object[] } >(`contacts`, {
      first_name: firstName,
      middle_name: middleName,
      last_name: lastName,
      type: type,
      phone: phone,
      email: email,
      sex: sex,
      relation_id: relationId,
    })
    return Contact.fromJson(json.data)
  }

  public async edit(contactId: string, firstName: string, middleName: string, lastName: string, type: ContactType, phone: string, email: string, sex: ContactSex|null, relationId: string): Promise<Contact> {
    const json = await this.putJson<{ data: object[] } >(`contacts/${contactId}`, {
      first_name: firstName,
      middle_name: middleName,
      last_name: lastName,
      type: type,
      phone: phone,
      email: email,
      sex: sex,
      relation_id: relationId,
    })
    return Contact.fromJson(json.data)
  }

  public async delete(contactId: string) {
    await this.deleteJson(`contacts/${contactId}`)
  }
}